var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWater = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 21,
  viewBox: "0 0 16 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.6 3.1C6.7 4 5.9 5 5.2 6c-.9 1.1-1.6 2.2-2.1 3.2-.9 1.5-1.3 2.8-1.3 3.7 0 3.7 2.8 6.3 6.2 6.3s6.2-2.6 6.2-6.3c0-.9-.4-2.2-1.3-3.7-.5-1-1.2-2.1-2.1-3.2-.7-1-1.5-2-2.4-2.9-.1-.2-.3-.4-.4-.5-.1.1-.3.3-.4.5M0 12.9c0-1.3.5-2.9 1.5-4.6.6-1.1 1.4-2.2 2.2-3.4.8-1 1.7-2.1 2.5-3 .3-.4.6-.7.8-.9l.4-.4L8 0l.6.6.4.4c.2.2.5.5.8.9.8.9 1.7 2 2.5 3 .8 1.2 1.6 2.3 2.2 3.4 1 1.7 1.5 3.3 1.5 4.6 0 4.8-3.7 8.1-8 8.1s-8-3.3-8-8.1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.2 13.4H8V15h-.8C5.6 15 4 13.9 4 11.8V11h1.6v.8c0 1 .8 1.6 1.6 1.6"
})));
export default SvgWater;